"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityUtils = void 0;
var SecurityConfig_1 = require("../interfaces/SecurityConfig");
var Regex_1 = require("../matchers/Regex");
var security_config_1 = require("./security-config");
var object_hash_1 = __importDefault(require("object-hash"));
var loggerPredefinedContants_1 = require("../constants/loggerPredefinedContants");
var SecurityUtils = (function () {
    function SecurityUtils(obfuscationThreshold, obfuscationOptOutConfig) {
        if (obfuscationThreshold === void 0) { obfuscationThreshold = loggerPredefinedContants_1.OBFUSCATION_FIELD_DEFAULT_THRESHOLD; }
        this.obfuscationOptOutMap = {};
        try {
            var securityConfig = (0, security_config_1.getSecurityConfig)();
            this.patternMatchers = securityConfig && securityConfig.patternMatchers;
            this.fieldNameMatchers = securityConfig && securityConfig.fieldNameMatchers;
            this.validateSecurityConfig();
            this.setMatcherLevelsToLowerCase();
            this.buildObfuscationOptOutMap(obfuscationThreshold, obfuscationOptOutConfig);
        }
        catch (error) {
            if (error) {
                error.code = error.code ? error.code : "HT_SECURITY_10000";
                var initError = "Initialization of \"SecurityUtils\" class failed during \"Logger\" instantiation. ";
                error.message = error.message ? initError + error.message : initError;
            }
            throw error;
        }
    }
    SecurityUtils.prototype.findPiiMatches = function (object, currentPiiLevel) {
        var _a;
        var piiLevelIndex = Infinity;
        var maxLevelIterated = 0;
        var lowerCaseCurrentPiiLevel = currentPiiLevel && typeof currentPiiLevel === 'string'
            && currentPiiLevel.toLowerCase();
        if (lowerCaseCurrentPiiLevel && SecurityUtils.isValidPiiLevel(lowerCaseCurrentPiiLevel)) {
            piiLevelIndex = SecurityConfig_1.PiiLevelPriority.indexOf(lowerCaseCurrentPiiLevel);
        }
        _a = this.iterativeSearchAndObfuscation(object, piiLevelIndex), piiLevelIndex = _a[0], maxLevelIterated = _a[1];
        return [SecurityConfig_1.PiiLevelPriority[piiLevelIndex], maxLevelIterated];
    };
    SecurityUtils.prototype.iterativeSearchAndObfuscation = function (object, currentPiiLevelIndex) {
        var stack = [];
        if (typeof object === 'object') {
            stack.push({ level: 0, iterableObject: object });
        }
        var stackHistory = {};
        var maxLevelIterated = 0;
        while (stack.length > 0) {
            var topElements = stack.pop();
            var iterableObject = topElements.iterableObject;
            if (!iterableObject || (iterableObject && Object.getOwnPropertyNames(iterableObject).length < 1)) {
                continue;
            }
            var objLevel = topElements.level;
            maxLevelIterated = Math.max(maxLevelIterated, objLevel);
            if (maxLevelIterated > loggerPredefinedContants_1.LOGGER_DEPTH_LEVEL_STOP_THRESHOLD) {
                currentPiiLevelIndex = 0;
                return [currentPiiLevelIndex, maxLevelIterated];
            }
            var hashIterableObject = (0, object_hash_1.default)(iterableObject);
            if (stackHistory[hashIterableObject] === true) {
                continue;
            }
            stackHistory[hashIterableObject] = true;
            var nextLevel = objLevel + 1;
            for (var key in Object.getOwnPropertyDescriptors(iterableObject)) {
                if (!key) {
                    continue;
                }
                if (iterableObject[key] && typeof iterableObject[key] === 'object' &&
                    Object.prototype.toString.call(iterableObject[key]) !== '[object Date]') {
                    if (this.checkFieldObfuscation(key)) {
                        iterableObject[key] = loggerPredefinedContants_1.OBFUSCATION_STRING;
                        continue;
                    }
                    stack.push({ level: nextLevel, iterableObject: iterableObject[key] });
                }
                else {
                    var fieldMatchPiiLevel = this.fetchFieldNameMatcherPiiLevelProrityIndex(key);
                    var patternMatchPiiLevel = this.fetchPatternMatcherPiiLevelPriorityIndex(iterableObject[key]);
                    if (this.checkFieldObfuscation(key)) {
                        iterableObject[key] = loggerPredefinedContants_1.OBFUSCATION_STRING;
                    }
                    else if (patternMatchPiiLevel !== Infinity && !this.obfuscationOptOutMap[key]) {
                        iterableObject[key] = loggerPredefinedContants_1.OBFUSCATION_STRING;
                    }
                    currentPiiLevelIndex = Math.min(currentPiiLevelIndex, fieldMatchPiiLevel, patternMatchPiiLevel);
                }
            }
        }
        return [currentPiiLevelIndex, maxLevelIterated];
    };
    SecurityUtils.prototype.checkFieldObfuscation = function (fieldName) {
        return this.obfuscationOptOutMap.hasOwnProperty(fieldName) && !this.obfuscationOptOutMap[fieldName];
    };
    SecurityUtils.prototype.fetchFieldNameMatcherPiiLevelProrityIndex = function (key) {
        var piiLevel = this.fieldNameMatchers[key];
        var levelIndex = SecurityConfig_1.PiiLevelPriority.indexOf(piiLevel);
        if (levelIndex > -1) {
            return levelIndex;
        }
        return Infinity;
    };
    SecurityUtils.prototype.fetchPatternMatcherPiiLevelPriorityIndex = function (value) {
        var _this = this;
        var patternMatchIndex = Infinity;
        if (!value || typeof value === 'object') {
            return patternMatchIndex;
        }
        var patternMatcherKeys = Object.keys(this.patternMatchers);
        var stringValue = value.toString();
        patternMatcherKeys.forEach(function (element) {
            if (patternMatchIndex === 0) {
                return patternMatchIndex;
            }
            if (stringValue.match(Regex_1.regexMatchers[element])) {
                var matchedElement = _this.patternMatchers[element];
                var levelIndex = SecurityConfig_1.PiiLevelPriority.indexOf(matchedElement);
                var matchedElementIndex = levelIndex > -1 ? levelIndex : patternMatchIndex;
                patternMatchIndex = Math.min(patternMatchIndex, matchedElementIndex);
            }
        });
        return patternMatchIndex;
    };
    SecurityUtils.prototype.buildObfuscationOptOutMap = function (obfuscationThreshold, obfuscationOptOutConfig) {
        for (var _i = 0, _a = Object.keys(this.fieldNameMatchers); _i < _a.length; _i++) {
            var key = _a[_i];
            this.obfuscationOptOutMap[key] = false;
        }
        if (obfuscationOptOutConfig && typeof obfuscationOptOutConfig === 'object') {
            var hasReservedWords = false;
            var reservedWordsFound = [];
            for (var _b = 0, _c = Object.keys(obfuscationOptOutConfig); _b < _c.length; _b++) {
                var key = _c[_b];
                if (loggerPredefinedContants_1.OBFUSCATION_RESERVED_WORDS.indexOf(key) > -1) {
                    hasReservedWords = true;
                    reservedWordsFound.push(key);
                }
                this.obfuscationOptOutMap[key] = obfuscationOptOutConfig[key];
            }
            if (hasReservedWords) {
                var errorMessage = "".concat(reservedWordsFound.join(', '), " fields(s) are reserved words and cannot be obfuscated. To resolve, please remove these fields from the obfuscation opt out values and try again.");
                var error = new Error(errorMessage);
                error.code = "HT_SECURITY_10006";
                throw error;
            }
        }
        if (Object.keys(this.obfuscationOptOutMap).length > obfuscationThreshold) {
            var errorMessage = "The opt out config list combined with internal logger fieldName fields have crossed the maximum threshold of ".concat(obfuscationThreshold, ". To resolve, please either remove some fields from the obfuscation opt out config list, or adjust obfuscationThreshold value.");
            var error = new Error(errorMessage);
            error.code = "HT_SECURITY_10005";
            throw error;
        }
    };
    SecurityUtils.prototype.validateSecurityConfig = function () {
        var patternMatcherObjectKeys = this.patternMatchers && Object.keys(this.patternMatchers);
        var isValidPatternMatcher = patternMatcherObjectKeys && patternMatcherObjectKeys.length > 0;
        var fieldMatcherObjectKeys = this.fieldNameMatchers && Object.keys(this.fieldNameMatchers);
        var isValidFieldNameMatcher = fieldMatcherObjectKeys && fieldMatcherObjectKeys.length > 0;
        if (!isValidPatternMatcher && !isValidFieldNameMatcher) {
            var patternMatchers = "Pattern Matchers:".concat(patternMatcherObjectKeys);
            var FieldNameMatchers = "Field Name Matchers:".concat(fieldMatcherObjectKeys);
            var message = 'Both "patternMatchers" and "fieldNameMatchers" are missing from' +
                ' "securityConfig" during initialization of "SecurityUtils" class.';
            var errorMessage = "".concat(message, " ").concat(patternMatchers, " ").concat(FieldNameMatchers);
            var error = new Error(errorMessage);
            error.code = "HT_SECURITY_10001";
            throw error;
        }
        var matcherLevels = this.fetchDistinctMatchersLevels();
        this.validatePatternMatchersHasRegex();
        this.validateMatchersLevelInLevelPriority(matcherLevels);
    };
    SecurityUtils.prototype.setMatcherLevelsToLowerCase = function () {
        var _this = this;
        if (this.patternMatchers) {
            Object.keys(this.patternMatchers).forEach(function (patternKey) {
                _this.patternMatchers[patternKey] = _this.patternMatchers[patternKey].toLowerCase();
            });
        }
        if (this.fieldNameMatchers) {
            Object.keys(this.fieldNameMatchers).forEach(function (fieldNameKey) {
                _this.fieldNameMatchers[fieldNameKey] =
                    _this.fieldNameMatchers[fieldNameKey].toLowerCase();
            });
        }
    };
    SecurityUtils.prototype.fetchDistinctMatchersLevels = function () {
        var levels = new Set();
        if (this.patternMatchers) {
            this.fetchDistinctLevels(Object.values(this.patternMatchers), levels);
        }
        if (this.fieldNameMatchers) {
            this.fetchDistinctLevels(Object.values(this.fieldNameMatchers), levels);
        }
        return Array.from(levels);
    };
    SecurityUtils.prototype.validatePatternMatchersHasRegex = function () {
        if (!this.patternMatchers) {
            return;
        }
        var missingRegexPatternKeys = [];
        var regexKeys = Object.keys(Regex_1.regexMatchers);
        var patternMatchersKeys = Object.keys(this.patternMatchers);
        for (var i = 0; i < patternMatchersKeys.length; i++) {
            var patternKey = patternMatchersKeys[i];
            if (!(regexKeys.includes(patternKey))) {
                missingRegexPatternKeys.push(patternKey);
            }
        }
        if (missingRegexPatternKeys.length > 0) {
            var message = 'Regex values not found for some "patternsMatchers"' +
                ', during initialization of "SecurityUtils" class.';
            var errorMessage = "".concat(message, " Missing Regex Keys: ").concat(missingRegexPatternKeys.toString(), " ") +
                "Pattern Matcher Keys: ".concat(patternMatchersKeys.toString());
            var error = new Error(errorMessage);
            error.code = "HT_SECURITY_10002";
            throw error;
        }
    };
    SecurityUtils.prototype.validateMatchersLevelInLevelPriority = function (matcherLevels) {
        var notInPriorityLevel = [];
        matcherLevels.forEach(function (level) {
            if (!SecurityUtils.isValidPiiLevel(level)) {
                notInPriorityLevel.push(level);
            }
        });
        if (notInPriorityLevel.length > 0) {
            var errorMessage = "\"patternMatcher\" or \"fieldNameMatcher\" Pii Level ".concat(notInPriorityLevel) +
                " is not defined in PiiLevelPriority constant ".concat(SecurityConfig_1.PiiLevelPriority.toString()) +
                ", during initialization of \"SecurityUtils\" class.";
            var error = new Error(errorMessage);
            error.code = "HT_SECURITY_10003";
            throw error;
        }
    };
    SecurityUtils.prototype.fetchDistinctLevels = function (levelKeys, levels) {
        var nonStringLevels = [];
        levelKeys.forEach(function (key) {
            if (typeof key === 'string') {
                levels.add(key.toLowerCase());
            }
            else {
                nonStringLevels.push(key);
            }
        });
        if (nonStringLevels.length > 0) {
            var message = "Some non-string matchers level values were encountered during" +
                " initialization of \"SecurityUtils\" class. ".concat(levelKeys);
            var error = new Error(message);
            error.code = "HT_SECURITY_10004";
            throw error;
        }
        return levels;
    };
    SecurityUtils.isValidPiiLevel = function (inputLevel) {
        return SecurityConfig_1.PiiLevelPriority.some(function (name) {
            return name === inputLevel;
        });
    };
    SecurityUtils.prototype.isPiiLevelHighestPriority = function (currentPiiLevel) {
        return currentPiiLevel === SecurityConfig_1.PiiLevelPriority[0];
    };
    return SecurityUtils;
}());
exports.SecurityUtils = SecurityUtils;
//# sourceMappingURL=security-utils.js.map